import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as types from '@reserve/store/types'
import { EnumCalendarViewType } from '../types';

import { FullMasterTemplate} from '@appbase/templates'
import GnbLeftView from '@gnb/views/GnbLeft/GnbLeftView.vue'

@Component ({
    components: {
        FullMasterTemplate,
        GnbLeftView    
    },

    computed: mapGetters({
        isLoading: types.CALENDAR_LOADING,
        calendarMode: types.CALENDAR_VIEWMODE   
    })
})
export default class ReserveMaster extends Vue {
    isLoading!: boolean;   
    calendarMode!: EnumCalendarViewType;        
}
